import { DomainEnum } from "@/config/constantsEnum";
interface MetaConfig {
  title?: string;
  description?: string;
  keywords?: string;
}

export const metaUtils = {
  /**
   * 更新网站元数据
   * @param config 配置对象，包含 title、description 等
   */
  updateMetaData(config: MetaConfig) {
    const { title, description, keywords } = config;

    // 更新标题
    if (title) {
      document.title = title;
    }
    // 更新描述
    if (description) {
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      }
    }

    // 更新关键词
    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute("content", keywords);
      }
    }
  },

  /**
   * 根据域名更新网站元数据
   */
  updateMetaByHostname() {
    const hostname = window.location.hostname;

    if (hostname.includes(DomainEnum.ZQSDAI)) {
      metaUtils.updateMetaData({
        title: "智启时代",
        description: "智启时代",
        keywords: "智启时代"
      });
    } else if (hostname.includes(DomainEnum.SNKXD_AI)) {
      metaUtils.updateMetaData({
        title: "晟诺科技",
        description: "晟诺科技",
        keywords: "晟诺科技"
      });
    } else if (hostname.includes(DomainEnum.BIHUO_AI)) {
      metaUtils.updateMetaData({
        title: "必火AI数字人|全网最真实的数字人和AI技术",
        description:
          "必火AI, 必火AI数字人, 数字人, AI, DeepSeek, 短视频数字人,直播数字人，互动数字人，全能数字人，虚拟数字人，最真实的数字人, AI技术, 数字人形象, 4K数字人",
        keywords:
          "必火AI致力于打造AI数字人一站式创作平台，提供最真实的数字人解决方案，包括真人数字人、全能数字人、虚拟数字人，以及定位、文案、拍摄、剪辑全链路，我们的使命是用AI助力更多人做好短视频营销。"
      });
    } else if (hostname.includes(DomainEnum.XMWSY)) {
      metaUtils.updateMetaData({
        title: "网视野",
        description: "网视野",
        keywords: "网视野"
      });
    } else {
      // 默认配置
      metaUtils.updateMetaData({
        title: "www.iiii.com|小冰数字人|DeepSeek",
        description:
          "DeepSeek,DeepSeekR1,www.iiii.com.小冰数字人,小冰数字人运营中心(DeepSeek)是一款云端智能视频创作平台，集成了小冰数字人、交互式数字人、素材收集、AI配音、AI绘画、视频编辑等功能，提供全面的数字人制作与发布解决方案。适合所有需要数字化表达和创作的个人和企业，帮助用户高效完成视频内容创作。",
        keywords:
          "DeepSeek,DeepSeekR1,www.iiii.com.小冰数字人, 数字人制作, AI视频创作, DeepSeek, 交互数字人, 直播技术, AI绘画, ChatAI, 视频编辑, AI配音, 数字人口播, 视频制作工具"
      });
    }
  }
};